/**
 * 路由配置
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import NProgress from 'nprogress';
Vue.use(VueRouter);

// 静态路由
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home')
  },
  {
    path: '/cgm',
    name: 'CGM',
    component: () => import('@/views/solution/cgm.vue')
  },
  {
    path: '/downloadsandguides',
    name: 'Download',
    component: () => import('@/views/support/download.vue')
  },
  {
    path: '/helpCenter',
    name: 'HelpCenter',
    component: () => import('@/views/support/helpCenter.vue')
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: () => import('@/views/support/faq.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/news')
  },
  {
    path: '/detail',
    name: 'newsDetail',
    component: () => import('@/views/news/detail.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/about')
  },
  {
    path: '/lang',
    name: 'Lang',
    component: () => import('@/views/lang')
  },
  {
    path: '/faqDetail',
    name: 'faqDetail',
    component: () => import('@/views/support/faqDetail.vue')
  },
  {
    path: '/boardOfDirectors',
    name: 'boardOfDirectors',
    component: () => import('@/views/about/boardOfDirectors.vue')
  },
  {
    path: '/index.html',
    redirect: '/'
  },
  {
    path: '*',
    redirect: '/'
  }
];

const router = new VueRouter({
  routes,
  mode: 'history'
});

/* 更新浏览器标题方法 */
const updateTitle = function (route) {
  if (!route?.path?.startsWith('/redirect/')) {
    const names = [];
    if (route?.meta?.title) {
      names.push(route.meta.title);
    }
    const appName = process.env.VUE_APP_NAME;
    if (appName) {
      names.push(appName);
    }
    document.title = names.join(' - ');
  }
};

// 路由守卫
router.beforeEach((to, from, next) => {
  const isSelectLang = localStorage.getItem('isSelectLang');
  // const isSelectLang = true;

  // console.log('是否选择国家 v-1119', isSelectLang);
  if (!isSelectLang && to.path !== '/lang') {
    next({
      path: '/lang',
      query: { redirect: to.fullPath }
    });
  } else {
    NProgress.start();
    updateTitle(to);
    window.scrollTo(0, 0);
    next();
  }
  // next();
});

router.afterEach(() => {
  setTimeout(() => {
    NProgress.done(true);
  }, 300);
});

export default router;
